module.exports = __webpack_public_path__ + "static/media/outlet.1b942e09.svg";